export default __webpack_public_path__ + "static/FuturaStdLight-2f13f262ce60c6b952aea185912f2e1f.woff2";